<template>
  <b-card class="bg-light text-center">
    <blockquote class="card-blockquote">
      <p class="mt-2" v-if="values && values.text">{{ values.text }}</p>
      <p class="mt-2" v-else>{{ 'empty_table_data_text' | translate('global') }}</p>
    </blockquote>
  </b-card>
</template>
<script>
export default {
  props: ['values'],
};
</script>
